module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allUserAssets":"All User Assets","remove":"Remove","close":"Close"},"es":{"allUserAssets":"Todos los activos del usuario","remove":"Remover","close":"Cerrar"}}')
  delete Component.options._Ctor
}
